import React, { HTMLAttributes, HTMLProps } from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  Taxonomy as TaxonomyTerm,
} from '@uncinc/react-drupal-core';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import useClasses from '../../../hooks/useClasses';
import { ViewTaxonomyProps } from '..';

import './style.scss';
import { MilestoneTaxonomyProps } from '../../Taxonomy';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entities: ViewTaxonomyProps['entities'];
}

const ViewBadges: React.FC<Props> = ({ entities, className }) => {
  const { t } = useTranslation();
  const { buildClass, joinClasses } = useClasses('ViewBadges');

  const userBadgeIds = useSelector<ImmutableRootState<MilestoneTaxonomyProps['field_badges']>>((state) => {
    const uid = state.getIn(['login', 'uid']);
    const badges = state.getIn(['user', uid, 'field_badges']);

    return badges.map((badge) => badge.getIn(['entity', 'tid', 0, 'value']));
  }) as Immutable.List<number>;

  if (entities.size === 0) {
    return null;
  }

  return (
    <div className={joinClasses(buildClass(), className)}>
      <div className={buildClass('title')}>
        <h2>{t('views.badges.title')}</h2>
      </div>

      <ul className={buildClass('list')}>
        {entities.map((entity) => {
          const id = entity.getIn(['tid', 0, 'value']);
          const uuid: string = entity.getIn(['uuid', 0, 'value']);
          const langcode: string = entity.getIn(['langcode', 0, 'value']);

          return (
            <TaxonomyTerm
              key={`${uuid}:${langcode}`}
              id={id}
              entity={entity}
              achieved={userBadgeIds.includes(id)}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default ViewBadges;
